import React, { useEffect, useState, createElement } from 'react';
import { Brain, Lock, Zap, Eye, Shield, ChevronRight, Play, CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
const COURSE_SECTIONS = [{
  title: 'Semana 1',
  subtitle: 'Reprograma tu Mente',
  description: 'Elimina el ruido mental y establece las bases de tu nueva identidad.',
  icon: Brain
}, {
  title: 'Semana 2',
  subtitle: 'Enfoque Profundo',
  description: 'Accede a estados alterados de concentración y claridad absoluta.',
  icon: Eye
}, {
  title: 'Semana 3',
  subtitle: 'Identidad Imparable',
  description: 'Despierta la versión más poderosa de ti mismo a nivel subconsciente.',
  icon: Shield
}, {
  title: 'Semana 4',
  subtitle: 'Éxito Automático',
  description: 'Programa tu sistema nervioso para operar en modo de alto rendimiento.',
  icon: Zap
}, {
  title: '7 Días para Activar Abundancia',
  subtitle: 'Bonus Final',
  description: 'El ritual de cierre que sella tu transformación y activa el flujo de abundancia.',
  icon: Lock
}];
export function MeditationsPage() {
  const [activeSection, setActiveSection] = useState<number | null>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    // Pixel base + init + PageView handled globally in App.tsx — removed here
    // to avoid double-counting.
  }, []);
  const fadeIn = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.6
    }
  };
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-purple-500/30" data-id="element-3420" data-mp="fgnkg1a5snbb">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-3421" data-mp="1c5mt3hennr41">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-3422" data-mp="1c88ypbhzjwjm" />
      </noscript>

      {/* Ambient Background */}
      <div className="fixed inset-0 z-0 pointer-events-none" data-id="element-3423" data-mp="12dyu8vfrr7sj">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-purple-900/10 rounded-full blur-[150px]" data-id="element-3424" data-mp="ydyhrgc8d6o4" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-indigo-900/8 rounded-full blur-[120px]" data-id="element-3425" data-mp="1uyqlkzg4zxx2" />
      </div>

      {/* Hero Section */}
      <section className="relative z-10 pt-12 md:pt-20 pb-16 md:pb-24 overflow-hidden" data-id="element-3426" data-mp="38tp9p7l2hz48">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-3427" data-mp="3dqyycl0mu6r0">
          {/* Badge */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 bg-purple-500/10 border border-purple-500/30 rounded-full px-5 py-2 mb-6" data-id="element-3428" data-mp="3ht2ma94hn3t6">
            <Lock className="w-4 h-4 text-purple-400" data-id="element-3429" data-mp="k70d39ktr54" />
            <span className="text-purple-400 text-xs md:text-sm font-bold uppercase tracking-widest" data-id="element-3430" data-mp="5bxab84lqcw0">
              Frequencia Prohibida
            </span>
          </motion.div>

          {/* Main Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-4xl md:text-6xl lg:text-7xl font-black uppercase leading-none tracking-tight mb-6" data-id="element-3431" data-mp="ecvfvuuousgp">
            Reprograma Tu Mente{' '}
            <span className="bg-gradient-to-r from-purple-400 via-violet-400 to-indigo-400 bg-clip-text text-transparent" data-id="element-3432" data-mp="pd7nvqwp3jm">
              En 30 Días
            </span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed mb-4" data-id="element-3433" data-mp="ahsrkylrk275">
            El método prohibido. La mente liberada. El nuevo tú.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto leading-relaxed mb-10" data-id="element-3434" data-mp="3nt1btcke1t6w">
            Basado en el{' '}
            <span className="text-white font-semibold" data-id="element-3435" data-mp="1aq8wrj2cacdr">
              Informe Gateway de la CIA
            </span>
            , este reto combina hipnosis encubierta, neurocondicionamiento y
            reprogramación de identidad para transformar tu mente en solo 30
            días.
          </motion.p>

          {/* Benefits Grid */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-2xl mx-auto mb-10 text-left" data-id="element-3436" data-mp="1te49czm7tk5a">
            {['Eliminar ruido mental y autocrítica', 'Acceder a estados de enfoque profundo', 'Despertar una identidad imparable', 'Programar tu sistema nervioso para el éxito automático'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white/[0.03] border border-white/[0.06] rounded-xl px-4 py-3" data-id="element-3437" data-mp="2h4892vwa8zr0" data-mpi={i}>
                <Brain className="w-5 h-5 text-purple-400 flex-shrink-0" data-id="element-3438" data-mp="2qzf6u7got8bd" />
                <span className="text-gray-200 text-sm md:text-base" data-id="element-3439" data-mp="2my3magco7da1">
                  {item}
                </span>
              </div>)}
          </motion.div>

          {/* Forbidden Note */}
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="text-gray-500 text-sm italic max-w-xl mx-auto mb-10" data-id="element-3440" data-mp="2d0z1ajuk9nut">
            No es un curso más, es el ritual mental que estuvo oculto por
            décadas… y ahora está en tus manos.
          </motion.p>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} data-id="element-3441" data-mp="1uar2gdxw9jkf">
            <a href="#curso" className="inline-block" data-id="element-3442" data-mp="1kcte7qg1bmrt">
              <button className="group relative bg-gradient-to-b from-purple-500 to-purple-700 hover:from-purple-400 hover:to-purple-600 text-white font-black text-lg md:text-xl uppercase tracking-wide rounded-xl py-5 px-12 shadow-[0_0_40px_rgba(168,85,247,0.3)] transition-all duration-300 transform hover:scale-[1.02] flex items-center gap-3" data-id="element-3443" data-mp="1a7tsieq6j7qc">
                <Play className="w-5 h-5 fill-white" data-id="element-3444" data-mp="1p4c5a4dxhzrk" />
                Empezar Curso
                <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-3445" data-mp="ri51gwpg8bg9">
                  <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-3446" data-mp="wh87ajd96lpa" />
                </div>
              </button>
            </a>

            {/* Progress */}
            <div className="mt-4 flex items-center justify-center gap-2" data-id="element-3447" data-mp="8qugew6emswa">
              <div className="flex gap-1" data-id="element-3448" data-mp="8oro25hs4noe">
                {[...Array(5)].map((_, i) => <div key={i} className="w-2 h-2 rounded-full bg-gray-700" data-id="element-3449" data-mp="do486ih9ngna" data-mpi={i} />)}
              </div>
              <span className="text-gray-500 text-xs font-medium" data-id="element-3450" data-mp="1rwnnsjgkmgbc">
                0 de 5 Lecciones Completadas
              </span>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Course Sections */}
      <section id="curso" className="relative z-10 py-16 md:py-24 scroll-mt-12" data-id="element-3451" data-mp="21ryxuoh1azcr">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-3452" data-mp="1wxbet54sux5k">
          <motion.div {...fadeIn} className="text-center mb-12" data-id="element-3453" data-mp="2atycxb8hntd2">
            <h2 className="text-3xl md:text-4xl font-black uppercase tracking-tight mb-3" data-id="element-3454" data-mp="26to7q0sit6z9">
              Tu Camino de{' '}
              <span className="text-purple-400" data-id="element-3455" data-mp="2kl2t2e9whk9h">Transformación</span>
            </h2>
            <p className="text-gray-400 text-base md:text-lg" data-id="element-3456" data-mp="2fl80m6ah8mmb">
              5 módulos diseñados para reprogramar cada capa de tu mente.
            </p>
          </motion.div>

          <div className="space-y-4" data-id="element-3457" data-mp="2ugmo6ygn4ex6">
            {COURSE_SECTIONS.map((section, index) => {
            const Icon = section.icon;
            const isActive = activeSection === index;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 15
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.08
            }} data-id="element-3458" data-mp="393v2471c2ycu" data-mpi={index}>
                  <button onClick={() => setActiveSection(isActive ? null : index)} className={`w-full text-left rounded-2xl border transition-all duration-300 ${isActive ? 'bg-purple-500/10 border-purple-500/40 shadow-[0_0_20px_rgba(168,85,247,0.1)]' : 'bg-white/[0.02] border-white/[0.06] hover:border-purple-500/20 hover:bg-white/[0.04]'}`} data-id="element-3459" data-mp="2ph6sspcqsmvd">
                    <div className="flex items-center gap-4 p-5 md:p-6" data-id="element-3460" data-mp="2lgd3psnkd20w">
                      <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors ${isActive ? 'bg-purple-500/20' : 'bg-white/[0.05]'}`} data-id="element-3461" data-mp="26jvy7i222hm9">
                        <Icon className={`w-6 h-6 ${isActive ? 'text-purple-400' : 'text-gray-500'}`} data-id="element-3462" data-mp="3rwiv9qkbenp3" />
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-3463" data-mp="s2a2ubpyouz">
                        <div className="flex items-center gap-2 mb-0.5" data-id="element-3464" data-mp="3hz4fzua4o4yd">
                          <span className="text-purple-400/60 text-xs font-bold uppercase tracking-wider" data-id="element-3465" data-mp="3i0z2ve4ym753">
                            {section.subtitle}
                          </span>
                        </div>
                        <h3 className="text-base md:text-lg font-bold text-white truncate" data-id="element-3466" data-mp="jgpgbg5mtka5">
                          {section.title}
                        </h3>
                      </div>
                      <ChevronRight className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform duration-300 ${isActive ? 'rotate-90' : ''}`} data-id="element-3467" data-mp="9r5ty0ipn8aj" />
                    </div>
                    {isActive && <div className="px-5 md:px-6 pb-5 md:pb-6 pt-0" data-id="element-3468" data-mp="xex694493lbt">
                        <div className="pl-16" data-id="element-3469" data-mp="1291hw0ogohj8">
                          <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-3470" data-mp="2mxlwocjiwhah">
                            {section.description}
                          </p>
                        </div>
                      </div>}
                  </button>
                </motion.div>;
          })}
          </div>
        </div>
      </section>

      {/* Mentor Section */}
      <section className="relative z-10 py-16 md:py-24 border-t border-white/[0.05]" data-id="element-3471" data-mp="2rqotctjlk6uw">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-3472" data-mp="23z9niqsm37ew">
          <motion.div {...fadeIn} data-id="element-3473" data-mp="1z0q2qtpr81o4">
            <div className="bg-gradient-to-br from-white/[0.03] to-white/[0.01] border border-white/[0.06] rounded-2xl p-6 md:p-10" data-id="element-3474" data-mp="1z1re6zaomq6d">
              <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10" data-id="element-3475" data-mp="28y46ptuhqxzj">
                {/* Avatar */}
                <div className="flex-shrink-0" data-id="element-3476" data-mp="3oebl4e5q7120">
                  <div className="w-24 h-24 md:w-32 md:h-32 rounded-2xl bg-gradient-to-br from-purple-500/20 to-indigo-500/20 border border-purple-500/20 flex items-center justify-center" data-id="element-3477" data-mp="3od1olteiu0xh">
                    <span className="text-4xl md:text-5xl font-black text-purple-400/50" data-id="element-3478" data-mp="2h1u7qiotvane">
                      GB
                    </span>
                  </div>
                </div>

                {/* Bio */}
                <div className="text-center md:text-left" data-id="element-3479" data-mp="2qyf8usxq81ly">
                  <p className="text-purple-400 text-xs font-bold uppercase tracking-widest mb-1" data-id="element-3480" data-mp="2v13lzcth3uoq">
                    Tu Mentor
                  </p>
                  <h3 className="text-2xl md:text-3xl font-black text-white mb-1" data-id="element-3481" data-mp="1ya1bmfegp9bg">
                    Gabriel Beltrán
                  </h3>
                  <p className="text-gray-400 text-sm font-medium mb-4" data-id="element-3482" data-mp="27bhmspd3pfgq">
                    Mentor de Alto Nivel en Marketing Digital
                  </p>
                  <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-3483" data-mp="2c53mlgy61ov4">
                    Gabriel Beltrán es la fuerza impulsora detrás de True
                    Marketer Academy. Su trayectoria combina el comercio
                    electrónico, el marketing de afiliados y el desarrollo
                    personal, y ha construido una reputación no solo por su
                    éxito financiero, sino por empoderar a otros a romper
                    barreras mentales y económicas.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="relative z-10 py-16 md:py-24 border-t border-white/[0.05]" data-id="element-3484" data-mp="t65td57pd79h">
        <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-3485" data-mp="od2wan3pvfoj">
          <motion.div {...fadeIn} data-id="element-3486" data-mp="je9sjme8f31k">
            <p className="text-purple-400 text-sm font-bold uppercase tracking-widest mb-4" data-id="element-3487" data-mp="jfb5jwet5zlx">
              ¿Estás listo?
            </p>
            <h2 className="text-3xl md:text-5xl font-black uppercase tracking-tight mb-6 leading-tight" data-id="element-3488" data-mp="fbd8rscyh0w1">
              Activa Tu Acceso y Despierta el{' '}
              <span className="bg-gradient-to-r from-purple-400 to-indigo-400 bg-clip-text text-transparent" data-id="element-3489" data-mp="5gbg4mjh1gop">
                Programa Oculto
              </span>{' '}
              Dentro de Ti
            </h2>
            <p className="text-gray-400 text-base md:text-lg mb-10 max-w-xl mx-auto" data-id="element-3490" data-mp="2aft8obvgvp9f">
              30 días. 5 módulos. Una transformación que no tiene vuelta atrás.
            </p>

            <a href="#curso" className="inline-block" data-id="element-3491" data-mp="20p8fj3ykbcxw">
              <button className="group relative bg-gradient-to-b from-purple-500 to-purple-700 hover:from-purple-400 hover:to-purple-600 text-white font-black text-lg md:text-xl uppercase tracking-wide rounded-xl py-5 px-12 shadow-[0_0_40px_rgba(168,85,247,0.3)] transition-all duration-300 transform hover:scale-[1.02] flex items-center gap-3 mx-auto" data-id="element-3492" data-mp="1mqs1st2a8m69">
                <Play className="w-5 h-5 fill-white" data-id="element-3493" data-mp="1hs77fa9powpq" />
                Empezar Ahora
                <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-3494" data-mp="377wwtlivpb84">
                  <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-3495" data-mp="3c4dkyfq2vpl7" />
                </div>
              </button>
            </a>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-3496" data-mp="1a9phxulfx7b4" />
    </div>;
}